import { FC } from 'react';
import { Navigate, Outlet } from 'react-router-dom';

import { useQuery, useUserVerify } from '@/hooks';

export const PublicRoute: FC = () => {
    const { isLoading, isError, isSuccess } = useUserVerify();

    const query = useQuery();

    if (isLoading) {
        return <div>Loading...</div>;
    }
    if (isError) {
        return <Outlet />;
    }

    if (isSuccess) {
        return <Navigate replace to={query.get('redirectUrl') ?? '/'} />;
    }

    return <Outlet />;
};
